exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-header h1 {\r\n    margin-top: 0;\r\n}\r\n\r\n.table td,\r\n.table th {\r\n    vertical-align: middle !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/Policies/policies.component.css
// module id = 567
// module chunks = 1